import type { RivalDef } from "./fixtures.ts";

/**
 * 「客户端用哪套造价」（cfg_main_common.cost_source），与服务端 src/game/cost-source.ts 同一套字符串：
 *   formula      公式：关卡制按目标造价 × 星形状摊；萌宠小镇按目标造价 × 级内形状摊到 10 颗星
 *   manual       手填：关卡制逐格实际造价；萌宠小镇逐星手填价
 *   rival:<id>   某一列竞品，原值照搬
 *   ""           还没选——草稿状态，发布闸会拦
 * 三套平级、都能发布（leo 2026-09-16）；切换不动任何一套的数值。
 */
export type CostSourceKind = "formula" | "manual" | "rival" | "";

export const COST_SOURCE_FORMULA = "formula";
export const COST_SOURCE_MANUAL = "manual";
const RIVAL_PREFIX = "rival:";

export function costSourceKind(v: string): CostSourceKind {
  if (v === COST_SOURCE_FORMULA) return "formula";
  if (v === COST_SOURCE_MANUAL) return "manual";
  if (v.startsWith(RIVAL_PREFIX)) return "rival";
  return "";
}

/** kind = rival 时的列 id；否则 null */
export const costSourceRival = (v: string): string | null => (v.startsWith(RIVAL_PREFIX) ? v.slice(RIVAL_PREFIX.length) : null);
export const rivalSource = (rivalId: string): string => `${RIVAL_PREFIX}${rivalId}`;

/** 界面上的名字：公式 / 手填 / 列名；还没选给 null（由调用方显示「未选」） */
export function costSourceName(v: string, rivals: RivalDef[], labels: { formula: string; manual: string }): string | null {
  const k = costSourceKind(v);
  if (k === "formula") return labels.formula;
  if (k === "manual") return labels.manual;
  if (k === "rival") return rivals.find((r) => r.id === costSourceRival(v))?.name ?? costSourceRival(v);
  return null;
}
